import React from 'react';
import { Sidebar, Tab } from 'semantic-ui-react';

import { useAppDispatch, useAppSelector } from 'src/store';
import drawer, { DrawerName } from 'src/store/ui/drawer';

import Discussion from './Discussion';
import Notes from './Notes';
import { useLocation } from 'react-router-dom';
import { classByIdSelector } from 'src/store/model/classes';
import { useResponsive } from 'ahooks';

const drawer_name: DrawerName = 'class_topic_content';

const panes = [
  {
    menuItem: {
      key: 'notes',
      content: 'NOTES',
    },
    render: () => <Notes />,
  },
  {
    menuItem: {
      content: 'DISCUSS',
      key: 'discussion',
    },
    render: () => <Discussion />,
  },
];

const ClassTopicContentDrawer: React.FC = () => {
  const { visible, name, extra } = useAppSelector((state) => state.ui.drawer);
  const dispatch = useAppDispatch();
  const screen = useResponsive();
  const { pathname } = useLocation();
  const isCisl = useAppSelector(
    (state) =>
      classByIdSelector(state, pathname.split('/')[2])?.type === 'CISL',
  );
  const visiblePanes = isCisl
    ? [{ ...panes[1], menuItem: { key: 'discussion', content: 'FORUM' } }]
    : panes;

  return (
    <Sidebar
      animation="overlay"
      icon="labeled"
      onHide={() => dispatch(drawer.close({ name: drawer_name }))}
      visible={visible && name === drawer_name}
      width={!screen.sm ? 'wide' : 'very wide'}
      direction={!screen.sm ? 'left' : 'right'}
      className="bg-white p-24"
    >
      <Tab
        className="custom_tab"
        panes={visiblePanes}
        activeIndex={
          isCisl ? 0 : panes.findIndex((p) => p.menuItem.key === extra)
        }
        menu={{ text: true }}
        onTabChange={(event, data) => {
          dispatch(
            drawer.open({
              extra: visiblePanes[data.activeIndex!].menuItem.key,
              name: drawer_name,
            }),
          );
        }}
      />
    </Sidebar>
  );
};

export default ClassTopicContentDrawer;
